import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config/api';
import { authFetch } from '../utils/authFetch';

export interface AnalyticsSummary {
  totalBalance: number;
  monthlyIncome: number;
  monthlyExpenses: number;
  savingsRate: number;
}

export function useAnalyticsSummary() {
  return useQuery<AnalyticsSummary>({
    queryKey: ['analyticsSummary'],
    queryFn: async () => {
      const response = await authFetch(`${API_URL}/analytics/summary/`);
      if (!response.ok) throw new Error('Failed to fetch analytics summary');
      return response.json();
    },
  });
} 